import { useQuery } from "@tanstack/react-query";
import { getSolar } from "@/api/solar";
import { SolarFilters } from "@/api/solar/types";


export function useSolar(filters?: SolarFilters) {
  return useQuery({
    queryKey: ['solar', filters],
    queryFn: () => getSolar(filters),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}